import React from "react"
import { RequiredSymbol } from "./various"
import { InputError } from "./inputError"
import { formGroup } from "./formGroup"
import { PropertiesNamesOfType } from "../componentExtensions"

interface TextInputProps<T> extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "name"> {
	label?: string;
	error?: string;
	helpText?: string;
	name?: PropertiesNamesOfType<T, string | undefined>;
}

export class TextInput<T = any> extends React.PureComponent<TextInputProps<T>>
{
	private input = React.createRef<HTMLInputElement>();

	render() {
		const { label, error, helpText, value, name, children, ...props } = this.props;

		const labelCmp = label ? <label className="form-label" htmlFor={name as any} onClick={e => this.input.current!.focus()}> {label}</label> : undefined;
		const required = this.props.required ? <RequiredSymbol /> : undefined;


		let component = (
			<>
				{labelCmp} {required}
				<input {...props} value={value} ref={this.input} name={name as any} />
				{children}
				<span className="form-text" style={{ display: helpText ? "" : "none" }}>{helpText || ""}</span>
				<InputError error={error} />
				<span className="bar" />
			</>);
		if (React.Children.count(children) > 0)
			return <div className="input-group">{component}</div>
		return (component);
	}
}

export const FormTextInput: <T>(props: TextInputProps<T>) => React.ReactElement | null = formGroup(TextInput as any) as any